export const upsell = {
  dismissalThreshold: 2,
  redemptionThreshold: 1
}
